import React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";

import { MessagePage } from "modules/layout/MessagePage";
import { AuthenticatedLayout } from "modules/layout/AuthenticatedLayout";

import { useAuthDataContext, Permissions } from "./AuthDataContext";
const signInPath = "/signin";

export const PrivateRoute = ({
  component: Component,
  requiredPermission,
  ...props
}: {
  component: React.ComponentType<unknown>;
  requiredPermission: Permissions;
} & RouteProps) => {
  const user = useAuthDataContext();
  // returning seperate routes based on auth state, rather than returning
  // a single route and switching on the inner component as this seemed
  // to cause the  entire application to re-mount whenever the 'user'
  // state changes (so you'd lose state of forms)
  return (
    <Route
      render={(renderProps) => {
        if (user.initializing)
          return (
            <MessagePage message="Please wait. Loading..." {...renderProps} />
          );
        if (!user.authenticated)
          return (
            <Redirect
              to={{
                pathname: signInPath,
                search: renderProps.location?.pathname
                  ? "?returnTo=" +
                    encodeURIComponent(renderProps.location?.pathname)
                  : "",
              }}
              {...renderProps}
            />
          );
        if (!user.enforcer.can(requiredPermission, renderProps.match.params))
          return (
            <MessagePage
              message="Sorry, that action is not permitted"
              {...renderProps}
            />
          );
        return (
          <AuthenticatedLayout>
            <Component {...renderProps} />
          </AuthenticatedLayout>
        );
      }}
      {...props}
    />
  );
};
